<template>
  <div id="furniture">
    <div class="table">
      <div class="table-top">
        <div class="plant">
          <div class="vase">
            <div class="flowers">
              <div class="flower">
                <div class="stem"></div>
                <div class="leaves">
                  <div class="leaf"></div>
                  <div class="leaf"></div>
                  <div class="leaf"></div>
                  <div class="leaf"></div>
                  <div class="leaf"></div>
                  <div class="leaf"></div>
                  <div class="leaf"></div>
                  <div class="leaf"></div>
                  <div class="leaf"></div>
                </div>
              </div>
              <div class="flower">
                <div class="stem"></div>
                <div class="leaves">
                </div>
              </div>
              <div class="flower">
                <div class="stem"></div>
                <div class="leaves">
                </div>
              </div>
            </div>
          </div>
        </div>
        <Book 
          :book="book"
        />
      </div>
      <div class="table-body">
        <div class="front">
          <div class="left-leg"></div>
          <div class="middle"></div>
          <div class="right-leg"></div>
        </div>
        <div class="right">
          <div class="left-leg"></div>
          <div class="middle"></div>
          <div class="right-leg"></div>
        </div>
        <div class="left">
          <div class="left-leg"></div>
          <div class="middle"></div>
          <div class="right-leg"></div>
        </div>
        <div class="back">
          <div class="left-leg"></div>
          <div class="middle"></div>
          <div class="right-leg"></div>
        </div>
      </div>
    </div>
    <Computer 
      :computer="computer"
    />
    <Armchair />
    <!-- <Poster 
      v-if="movie"
      :poster="movie"
    />
    <Poster 
      v-if="movie2"
      :poster="movie2"
      class="second"
    /> -->
    <div class="trestle">
      <div class="sides">
        <div class="bottom"></div>
      </div>
    </div>
    <div class="trestle second">
      <div class="sides">
        <div class="bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Armchair from './Armchair.vue'
import Book from './Book'
import Computer from './Computer'
// import Poster from './Poster'

export default {
  name: "Furniture",
  components: {
    Book,
    Computer,
    // Poster,
    Armchair,
  },
  data () {
    return {
      book: '',
      computer: '',
      // movie: '',
      // movie2: ''
    }
  },
  created() {
    // this.$http.get(this.$apiURL + '/movie')
    //   .then((response) => { this.movie = response.data })
    //   .catch((error) => { console.log(error) })
    // this.$http.get(this.$apiURL + '/movie-2')
    //   .then((response) => { this.movie2 = response.data })
    //   .catch((error) => { console.log(error) })
    this.$http.get(this.$apiURL + '/book')
      .then((response) => { this.book = response.data })
      .catch((error) => { console.log(error) })
    this.$http.get(this.$apiURL + '/computer')
      .then((response) => { this.computer = response.data })
      .catch((error) => { console.log(error) })
  }
}
</script>

<style>

#furniture div {
  box-sizing: border-box;
}
#furniture .table {
  position: absolute;
  left: 400px;
  top: -50px;
  display: flex;
  flex-direction: column;
}
#furniture .table .table-top {
  width: 120px;
  height: 20px;
  z-index: 1;
  background: linear-gradient(to top, var(--orange-wood), var(--light-orange-wood));
  border-bottom: 5px ridge var(--orange-wood);
  border-right: 5px ridge var(--orange-wood);
  display: flex;
}
#furniture .table .table-body {
  transform-origin: top right;
  transform: skewX(70deg);
  width: 120px;
  height: 60px;
  display: flex;
}
#furniture .table .table-body div {
}
#furniture .table .table-body div .left-leg {
  width: 4.5px;
  background: linear-gradient(to top, var(--orange-wood), var(--light-orange-wood));
}
#furniture .table .table-body div .middle {
  flex: 1 0 auto;
  height: 8px;
  background: linear-gradient(to top, var(--orange-wood), var(--light-orange-wood));
}
#furniture .table .table-body div .right-leg {
  width: 4.5px;
  background: linear-gradient(to top, var(--orange-wood), var(--light-orange-wood));
}
#furniture .table .table-body .front {
  flex: 1 0 auto;
  display: flex;
  justify-content: space-between;
}
#furniture .table .table-body .front .left-leg {
}
#furniture .table .table-body .front .middle {
}
#furniture .table .table-body .front .right-leg {
}
#furniture .table .table-body .right {
  position: absolute;
  top: 0;
  right: 0;
  height: 60px;
  width: 55px;
  transform-origin: top right;
  transform: skewY(-20deg) rotateZ(180deg) rotateX(180deg);
  display: flex;
  justify-content: space-between;
}
#furniture .table .table-body .right .left-leg {
}
#furniture .table .table-body .right .middle {
}
#furniture .table .table-body .right .right-leg {
}
#furniture .table .table-body .left {
  position: absolute;
  top: 0;
  left: 0;
  height: 60px;
  width: 55px;
  transform-origin: top left;
  transform: skewY(-20deg) rotateZ(180deg) rotateX(180deg) rotateY(180deg);
  display: flex;
  justify-content: space-between;
}
#furniture .table .table-body .left .left-leg {
}
#furniture .table .table-body .left .middle {
}
#furniture .table .table-body .left .right-leg {
}
#furniture .table .table-body .back {
  position: absolute;
  top: 0;
  left: 0;
  height: 60px;
  width: 120px;
  transform: translate(55px, -20px);
  display: flex;
  justify-content: space-between;
}
#furniture .table .table-body .back .left-leg {
}
#furniture .table .table-body .back .middle {
}
#furniture .table .table-body .back .right-leg {
}
#furniture .table .table-top .plant {
  position: absolute;
  left: -150px;
  bottom: 73px;
  width: 15px;
  height: 60px;
  transform-origin: top right;
  transform: skewX(70deg);
  display: flex;
  pointer-events: none;
}
#furniture .table .table-top .plant .vase {
  flex: 1 0 auto;
}
#furniture .table .table-top .plant .vase::after {
  content: '';
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background: var(--glass-day);
  border-radius: 30%/50%;
  border: 0.5px solid lightgrey;
}
.flowers {
}
.flowers .flower {
  height: 100%;
  width: 20px;
  margin-top: -40px;
  margin-left: 8px;
}
.flowers .flower .stem { 
  width: 100%;
  height: 100%;
  border-left: 2px solid var(--pale-green);
  border-radius: 50%/60px;
}
.flowers .flower .leaves { 
  position: absolute;
  top: -40px;
  width: 10px;
  transform: rotate(10deg);
  display: flex;
  flex-wrap: wrap;
}
.flowers .flower .leaves .leaf { 
  width: 4px;
  height: 8px;
  margin-top: -4px;
  border-radius: 90% / 100%;
  border: 0.5px solid var(--leaf-border);
  background: var(--leaf);
  transform: rotate(-20deg);
}
#furniture .table .table-top .plant .vase .flowers .flower {
  height: 100px;
}
#furniture .table .table-top .plant .vase .flowers .flower:nth-of-type(2) {
  position: absolute;
  top: 0;  
  left: -20px;
}
#furniture .table .table-top .plant .vase .flowers .flower:nth-of-type(3) {
  position: absolute;
  top: 0;  
  left: 2px;
  height: 110px;
  margin-top: -50px;
}
#furniture .table .table-top .plant .vase .flowers .flower:nth-of-type(2) .stem {
  transform: rotate(178deg);
}
#furniture .table .table-top .plant .vase .flowers .flower:nth-of-type(3) .stem {
  transform: rotate(8deg);
}
#furniture .table .table-top .plant .vase .flowers .flower .leaf:nth-child(odd) { 
  transform: rotate(20deg);
}
#furniture .table .table-top .plant .vase .flowers .flower .leaf:nth-child(1) { 
  transform: rotate(10deg);
  margin-left: 2.5px;
}
#furniture .trestle {
  transform-origin: bottom left;
  transform: skewX(70deg) skew(-3deg);
  position: absolute;
  left: 1560px;
  bottom: -5px;
  height: 100px;
  width: 130px;
  display: flex;
  justify-content: center;
  border-top: 6px solid var(--light-wood);
}
#furniture .trestle.second {
  transform: skewX(70deg) skew(-4deg);
  left: 1557px;
  bottom: -5px;
  filter: brightness(1.2);
}
#furniture .trestle .sides {
  height: 100%;
  width: 80%;
  display: flex;
  justify-content: center;
  border-left: 6px solid  var(--light-wood);
  border-right: 6px solid var(--light-wood);
}
#furniture .trestle .sides .bottom {
  width: 100%;
  height: 90%;
  border-bottom: 6px solid  var(--light-wood);
}

</style>


